import { sagaSearchSuccess, sagaSearchFailed, sagaDeleteSuccess } from "../actions/ActionTypes";

import ApiFetcher from "../utils/ApiFetcher";

const initialState = { results: [], searching: false , deleteCompleted: false};

const createCSVDOwnload = (data, filename) => {
  var encodedUri = 'data:application/csv;charset=utf-8,' + encodeURIComponent(data);
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${filename}.csv`);
  link.innerHTML= "Download do Relatório";
  document.body.appendChild(link);
  link.click();
}


const MEMBERS = "members";
const MEMBER = "member";
export default function search(state = initialState, action = {}) {
  switch (action.type) {
    case 'DOWNLOAD_MEMBERS':

      const apiFetcher = new ApiFetcher();
      apiFetcher.makeRequest('POST', '/api/members/download', {kind: action.data}).then(res => {
        console.log(res)
        createCSVDOwnload(res.data, 'ridge-member-list');
      })
      return state;

    case "MEMBER_RESET":
      return { ...state, results: [] };

    case "MEMBER_SEARCHING":
      return { ...state, searching: true };

    case "REMOVE_MODAL_CLOSED" :
      return {...state, deleteCompleted: false};

    case sagaSearchSuccess(MEMBERS):
      return { ...state, results: action.data.data, searching: false };
    case sagaSearchFailed(MEMBERS):
      return { ...state, searching: false };

    case sagaDeleteSuccess(MEMBER):
      const {id} = action.data;
      const newResults =state.results.filter(m => m.id !== id);
      return {...state,  results: newResults, deleteCompleted: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/search.js